import FJConfig from '../config/FJConfig'
import FJNetworkStore from './FJNetworkStore'

/**
 * @class FJLocalStore
 * @classdesc 本地化管理器
 */
let FJLocalStore = (function () {
  let curTag = 'en';
  let language = {};

  return {
    /**
     * @param {string} key
     * @return {*}
     * @private
     */
    _: function (key) {
      let value = language[curTag] && language[curTag][key];
      return value || key;
    },

    /**
     * @return {Promise<Object>}
     */
    init: async function () {
      let {
        languagePath,
        buildVersion,
      } = FJConfig;
      let path = languagePath + curTag + '.json?v=' + buildVersion;
      language[curTag] = await FJNetworkStore.initLanguage(path);
    },

    /**
     * @description 返回当前tag
     * @return {string}
     */
    curTag: function () {
      return curTag;
    }
  }
})();

export default FJLocalStore;
